import React from 'react';
import { DatePicker } from 'antd';
import SupplierRegionsLocationsTreeSelect from '../regions_tree_select/SupplierRegionsLocationsTreeSelect';
import { DateRange } from '../field_techs_overview_wrench_mode_logs_page/WrenchModeLogsSidebar';

const { RangePicker } = DatePicker;

const LOCATION_TARGET_COLLECTION = 'wrenchModeLogsLocationFilter';

interface WrenchModeDetailHeaderProps {
	dateRange: DateRange;
	onRangeChange: (range: DateRange) => void;
	locationIds: number[] | undefined;
	onLocationChange: (ids: number[] | undefined) => void;
}

const WrenchModeDetailHeader: React.FC<WrenchModeDetailHeaderProps> = ({
	dateRange,
	onRangeChange,
	locationIds,
	onLocationChange,
}) => {
	return (
		<div className="flex items-center gap-s p-xs">
			<RangePicker
				value={[dateRange.from, dateRange.to]}
				onChange={(dates) => {
					if (dates && dates[0] && dates[1]) {
						onRangeChange({
							from: dates[0].clone().startOf('day'),
							to: dates[1].clone().endOf('day'),
						});
					}
				}}
				allowClear={false}
				style={{ width: 280 }}
			/>
			<div style={{ width: 300 }}>
				<SupplierRegionsLocationsTreeSelect
					targetCollectionName={LOCATION_TARGET_COLLECTION}
					placeholder="Filter by location"
					mode="multiple"
					value={locationIds}
					onChange={(val) => {
						const ids = Array.isArray(val) && val.length > 0 ? val.map(Number) : undefined;
						onLocationChange(ids);
					}}
				/>
			</div>
		</div>
	);
};

export default WrenchModeDetailHeader;
